export const TableHelpers = {
    data() {
        return {
            tableColumns: [{
                title: this.$t('Expediente'),
                type: 'custom-html',
                key: 'accreditation_applications',
                modifier: (item) => {
                    return `<a href="/accreditations/applications/${item.id}" target="_blank">${item.record || ''}</a>`;
                }
            },
            {
                title: this.$t('Tipo acreditación'),
                type: 'custom-html',
                key: 'accreditation_applications',
                modifier: (value) => {
                    return value.accreditation_type.name;
                }
            },
            {
                title: 'OEC',
                type: 'custom-html',
                key: 'accreditation_applications',
                modifier: (value) => {
                    return value.organization.business_name;
                }
            },
            {
                title: 'Tipo',
                type: 'custom-html',
                key: 'type',
                modifier: (value) => {
                    let val = value;
                    if (val == "E") {
                        return "EVALUACION";
                    }
                    if (val == "T") {
                        return "TESTIFICACIÓN";
                    }
                }

            },
            {
                title: this.$t('Código'),
                type: 'text',
                key: 'code',
            },

            {
                title: this.$t('Fecha creación'),
                type: 'custom-html',
                key: 'created_at',
                modifier: (value) => {
                    if (value) {
                        return moment(value).format("YYYY-MM-DD");
                    }
                }
            },
            {
                title: this.$t('Estado'),
                type: 'custom-html',
                key: 'status',
                modifier: (value) => {

                    return value.name;
                }
            },
            {
                title: this.$t('Replanificación'),
                type: 'custom-html',
                key: 'replanning_counter',
                modifier: (value) => {
                    if (value == 1) {
                        return `<span class="badge badge-sm badge-pill badge-danger">Replanificación</span>`;
                    } else {
                        return 'No';
                    }

                }
            },
            {
                title: this.$t('Observacion'),
                type: 'custom-html',
                key: 'observations_evaluation_team',
                modifier: (value) => {
                    if (value.length > 0) {
                        return `<span class="badge badge-sm badge-pill badge-danger">SI</span>`;
                    } else {
                        return 'No';
                    }

                }
            }
            ],
            actionObj: {
                title: this.$t('Acciones'),
                type: 'action',

            }
        }
    },
}